export default [
	{
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Date Time',
		width: 150,
		align: 'center',
		scopedSlots: {customRender: 'datetime'}
	}, {
		key: 'file',
		title: "File",
		scopedSlots: {customRender: 'file'}
	}, {
		dataIndex: 'mime',
		key: 'mime',
		title: '',
		scopedSlots: {customRender: 'mime'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		scopedSlots: {customRender: 'action'}
	}
]
